FormCopyService = ($window) ->
  body = angular.element($window.document.body)
  spanTag = document.createElement('span')
  spanTag.style = "position: absolute ; opacity: 0 ; width : 0; height : 0 ; top : 0 ; left: 0"

  copy:(text) ->
    spanTag.innerText = text
    body.append(spanTag)
    range = document.createRange()
    range.selectNode(spanTag)

    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)

    try
      success = document.execCommand('copy')
      if !success
        throw success
    catch error
      window.prompt("Copy to clipboard: Ctrl+C, Enter", text)

    window.getSelection().removeAllRanges()
    spanTag.remove()



FormCopyService.$inject = [
  '$window'
]

module.exports = FormCopyService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/form-copy-service.coffee